<div id="iqac">
    
    <div class="conatiner-fluid">
        <router-outlet></router-outlet>
    </div>
</div>